module.exports = __webpack_public_path__ + "media/site/images/products/omms-screen@2x-64bbb313db88e1704727a940e6af7f01.png";